import { render, staticRenderFns } from "./TaskViewChecklistPopup.vue?vue&type=template&id=1afc9ac8&scoped=true&lang=pug&"
import script from "./TaskViewChecklistPopup.vue?vue&type=script&lang=js&"
export * from "./TaskViewChecklistPopup.vue?vue&type=script&lang=js&"
import style0 from "./TaskViewChecklistPopup.vue?vue&type=style&index=0&id=1afc9ac8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afc9ac8",
  null
  
)

export default component.exports